interface Window {
  VAC_DEBUG?: boolean;
}

declare let window: Window;

interface LoggerType {
  log: (...args: any[]) => void;
  info: (...args: any[]) => void;
  error: (...args: any[]) => void;
}

const Logger: LoggerType = (() => {
  const LOG_PREFIX = '::VAC::';

  // Are we in debug mode?
  function debug(): boolean {
    return !!window.VAC_DEBUG;
  }

  // Build arguments for console fn, adding prefix
  function buildArgs(args: any[]): any[] {
    return [LOG_PREFIX].concat(args);
  }

  return {
    log: (...args: any[]): void => {
      if (!debug()) return;
      console.log(...buildArgs(args));
    },
    info: (...args: any[]): void => {
      if (!debug()) return;
      console.info(...buildArgs(args));
    },
    error: (...args: any[]): void => {
      if (!debug()) return;
      console.error(...buildArgs(args));
    }
  };
})();

export default Logger;

